<script lang="ts" setup>
import {
  UNIFIED_DEV_AWARD_COINS,
  UNIFIED_DEV_CLEAR_USER_PROGRESS,
  UNIFIED_DEV_TOGGLE_PHONE_VERIFICATION,
} from '~/graphql/documents/unified';

const client = useUrqlClient();
const { show: showToast } = useToast();
const { studentRoles, fetchUser } = useAuth();

const isPhoneVerified = computed(() =>
  studentRoles.value.some(role => role.isPhoneNumberProvidedAndVerified),
);

const awardCoins = async () => {
  try {
    const result = await client.mutation(UNIFIED_DEV_AWARD_COINS, {});
    if (result.error) {
      throw result.error;
    }
    showToast({ variant: 'success', message: 'Awarded 1000 coins' });
  }
  catch {
    showToast({ variant: 'error', message: 'Failed to award coins' });
  }
};

const togglePhone = async () => {
  try {
    const result = await client.mutation(UNIFIED_DEV_TOGGLE_PHONE_VERIFICATION, {});
    if (result.error) {
      throw result.error;
    }
    await fetchUser(true);
    showToast({ variant: 'success', message: 'Phone verification toggled' });
  }
  catch {
    showToast({ variant: 'error', message: 'Failed to toggle phone verification' });
  }
};

const clearProgress = async () => {
  try {
    const result = await client.mutation(UNIFIED_DEV_CLEAR_USER_PROGRESS, {});
    if (result.error) {
      throw result.error;
    }
    showToast({ variant: 'success', message: 'User progress cleared' });
  }
  catch {
    showToast({ variant: 'error', message: 'Failed to clear user progress' });
  }
};
</script>

<template>
  <div class="px-3 py-1">
    <div class="flex flex-col gap-1.5">
      <div class="grid grid-cols-2 gap-1.5">
        <button
          class="rounded-md px-2 py-0.5 text-xs font-medium text-white bg-success-foreground hover:bg-success-foreground/90"
          @click="awardCoins"
        >
          Award 1000 Coins
        </button>
        <button
          class="rounded-md px-2 py-0.5 text-xs font-medium text-white"
          :class="isPhoneVerified ? 'bg-primary hover:brightness-90' : 'bg-info-foreground hover:bg-info-foreground/90'"
          @click="togglePhone"
        >
          {{ isPhoneVerified ? 'Unverify Phone' : 'Verify Phone' }}
        </button>
        <button
          class="col-span-2 rounded-md px-2 py-0.5 text-xs font-medium text-white bg-destructive hover:bg-destructive/90"
          @click="clearProgress"
        >
          Clear All Progress + Coins + Awards
        </button>
      </div>
    </div>
  </div>
</template>
